import { Incasso } from 'src/app/common/models/incasso';
import { IncassoSoggetto } from 'src/app/common/models/incasso-soggetto';

export class IncassoSoggettoAdapter {
  incassoSoggetto: IncassoSoggetto = new IncassoSoggetto();
  constructor(incassoSoggetto: IncassoSoggetto, incasso: Incasso) {
    this.incassoSoggetto.id = incassoSoggetto.id ? incassoSoggetto.id : null;
    this.incassoSoggetto.soggetto = incassoSoggetto.soggetto  ?  JSON.parse(JSON.stringify(incassoSoggetto.soggetto)) : null;
    this.incassoSoggetto.percentualeIncasso = incassoSoggetto.percentualeIncasso ? incassoSoggetto.percentualeIncasso : null;
    this.incassoSoggetto.incasso = incasso  ?  JSON.parse(JSON.stringify(incasso)) : null;
  };

}
